"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v1/web-resources")
);
let SelectHasWebPageDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.groupLists = [];
    this.groupTree = [];
    this.gridController = _gridController;
    this.choosedGroupId = "";
    this.searchInputStr = "";
    this.groupProps = {
      label: "name",
      children: "children"
    };
    this.selectedItems = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(selectItems) {
    return __async(this, null, function* () {
      try {
        if (selectItems) {
          this.selectedItems = selectItems;
        }
        this.dialog.visible = true;
        yield this.getResourceGroupTree();
        this.gridController.query.filter = `groupId == ${this.choosedGroupId};createdTime=sort=desc`;
        yield this.gridController.search();
        this.$nextTick(function() {
          this._departmentTree.setCurrentKey(this.choosedGroupId);
          this.checkSelectedGrid();
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refresh(selectItems) {
    return __async(this, null, function* () {
      try {
        if (selectItems) {
          this.selectedItems = selectItems;
        }
        yield this.getResourceGroupTree();
        this.gridController.query.filter = `groupId == ${this.choosedGroupId};createdTime=sort=desc`;
        yield this.gridController.search();
        this.$nextTick(function() {
          this._departmentTree.setCurrentKey(this.choosedGroupId);
          this.checkSelectedGrid();
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getResourceGroupTree() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v1/web-resource-groups`
        );
        this.groupLists = response.data.datas;
        this.handleGroupListChangeTree(this.groupLists);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  searchGridByGroupChange() {
    return __async(this, null, function* () {
      if (this.searchInputStr === "" || this.searchInputStr === null) {
        this.gridController.query.filter = `groupId == ${this.choosedGroupId};createdTime=sort=desc`;
      } else {
        this.gridController.query.filter = `(name=like='${this.searchInputStr}',url=like=${this.searchInputStr},description=like=${this.searchInputStr});groupId == ${this.choosedGroupId};createdTime=sort=desc`;
      }
      this.gridController.query.current = 1;
      yield this.gridController.search();
      this.$nextTick(function() {
        this.checkSelectedGrid();
      });
    });
  }
  checkGridSelected() {
    this.checkSelectedGrid();
  }
  openGroupManager() {
    this.$emit("openGroupDialog");
  }
  searchByAnyData(input) {
    return __async(this, null, function* () {
      try {
        if (input === "" || input === null) {
          this.gridController.query.filter = `groupId == ${this.choosedGroupId};createdTime=sort=desc`;
        } else {
          this.gridController.query.filter = `(name=like='${input}',url=like=${input},description=like=${input});groupId == ${this.choosedGroupId};createdTime=sort=desc`;
        }
        yield this.gridController.search();
        this.$nextTick(function() {
          this.checkSelectedGrid();
        });
      } catch (error) {
      }
    });
  }
  handleGroupListChangeTree(list) {
    let arr = [];
    for (let item of list) {
      if (item.parentId === "root") {
        this.getTrees(item);
        arr.push(item);
      }
    }
    this.groupTree = arr;
  }
  getTrees(item) {
    item.children = [];
    for (let data of this.groupLists) {
      if (data.parentId === item.id) {
        if (this.choosedGroupId === "") {
          this.choosedGroupId = data.id;
        }
        item.children.push(data);
      }
    }
  }
  //检测当前列表选中的数据
  checkSelectedGrid() {
    for (let item of this.selectedItems) {
      let selectedData = _.find(this.gridController.result.datas, { "id": item.id });
      if (selectedData !== void 0) {
        this._uiGrid._tableBody.toggleRowSelection(selectedData, true);
      }
    }
  }
  handleCheckChange(data, dataNode) {
    return __async(this, null, function* () {
      this.choosedGroupId = data.id;
      yield this.searchGridByGroupChange();
    });
  }
  openDomsDialog(data) {
    return __async(this, null, function* () {
      try {
        console.log(data);
      } catch (error) {
      }
    });
  }
  selectItems(items) {
    let ids = _.map(items, "id");
    let selected_ids = _.map(this.selectedItems, "id");
    let unSelectData = _.differenceWith(
      selected_ids,
      ids,
      _.isEqual
    );
    for (let item of items) {
      let data = _.find(this.selectedItems, { id: item.id });
      if (data === void 0) {
        this.selectedItems.push(item);
      }
    }
    for (const item of unSelectData) {
      const data = _.findIndex(this.selectedItems, { id: item });
      let searchresult = _.find(this.gridController.result.datas, { id: item });
      if (searchresult !== void 0) {
        this.selectedItems.splice(data, 1);
      }
    }
  }
  cancel() {
    this.selectedItems = [];
    this.dialog.visible = false;
  }
  confirm() {
    return __async(this, null, function* () {
      try {
        this.$emit("submitSelected", this.selectedItems);
        this.cancel();
      } catch (error) {
      }
    });
  }
};
__decorateClass([
  Ref("department-tree")
], SelectHasWebPageDialog.prototype, "_departmentTree", 2);
__decorateClass([
  Ref("uiGrid")
], SelectHasWebPageDialog.prototype, "_uiGrid", 2);
__decorateClass([
  Debounce(400)
], SelectHasWebPageDialog.prototype, "searchByAnyData", 1);
__decorateClass([
  Debounce(400)
], SelectHasWebPageDialog.prototype, "selectItems", 1);
SelectHasWebPageDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid
    }
  })
], SelectHasWebPageDialog);
export {
  SelectHasWebPageDialog as default
};
